// extracted by mini-css-extract-plugin
export default {"container":"Dp-z","bubbleNav":"Ep-z","graphic":"Fp-z","contact":"Gp-z"};